// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";

/**
 * Shared page-level loader. Use for full-page loading states so every page
 * shows the same spinner + message pattern.
 *
 * Usage:
 *   if (loading) return <PageLoader message="Lade Sperrzeiten..." />;
 */
const PageLoader = ({ message = "Lädt..." }) => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary-color mx-auto mb-4"></div>
      <p className="text-lg text-gray-600 dark:text-slate-400 font-medium">
        {message}
      </p>
    </div>
  </div>
);

export default PageLoader;
